import axios from "axios";
import { getTokenLocal, handleSessionExpired } from "../utils/localStorage.util";

const baseURL = process.env.REACT_APP_API_URL;

export class HttpClient {
  constructor(baseURL) {
    this.instance = axios.create({
      baseURL,
    });
    this._initializeRequestInterceptor();
    this._initializeResponseInterceptor();
  }

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use((config) => {
      const token = getTokenLocal();
      if (token) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    });
  };

  _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      this._handleResponse,
      this._handleError
    );
  };

  _handleResponse = (response) => {
    const code = response?.data?.code || response?.data?.statusCode;
    const status = response?.data?.status;
    const msg = (response?.data?.message || "").toLowerCase();

    if (
      code === 401 ||
      (status === "failed" &&
        (code === 201 ||
          code === 401 ||
          msg.includes("unauthorized") ||
          msg.includes("invalid or expired token")))
    ) {
      handleSessionExpired();
    }
    return response;
  };

  _handleError = async (error) => {
    const status = error?.response?.status || error?.status;
    const msg = (error?.response?.data?.message || error?.message || "").toLowerCase();

    if (
      status === 401 ||
      status === 403 ||
      msg.includes("unauthorized") ||
      msg.includes("invalid or expired token")
    ) {
      handleSessionExpired();
    }

    return Promise.resolve(error?.response || error);
  };
}

export default HttpClient;
